import { createFileRoute } from "@tanstack/solid-router";
import { lazy } from "solid-js";

import { App } from "@/components/base/app";

const LoaderPerspective = lazy(async () => {
	const mod = await import("@/components/base/loader-perspective");
	return { default: mod.LoaderPerspective };
});

const Route = createFileRoute("/$slug/")({
	ssr: false,
	component: () => {
		const params = Route.useParams();

		return (
			<App>
				<LoaderPerspective slug={params().slug} />
			</App>
		);
	},
});

export { Route };
